import { render, staticRenderFns } from "./DefaultMessage.vue?vue&type=template&id=6cbe34c6&scoped=true"
import script from "./DefaultMessage.vue?vue&type=script&lang=js"
export * from "./DefaultMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbe34c6",
  null
  
)

export default component.exports